module.exports = "./img/66eda6c2ce1699a612de20681c702d22.jpg";